module.exports = __webpack_public_path__ + "static/img/wx.36c2d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx.png
// module id = qSza
// module chunks = 1